import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../services/api.service';
import {RSLoadingModalService} from '../../../libs/rsloading/rsloading.service';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {DataService} from '../../services/data.service';
import invert, { RGB, RgbArray, HexColor, BlackWhite } from 'invert-color';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {AddCategoryComponent} from '../add-category/add-category.component';
import defaultValues = RSDialog.defaultValues;
import {AssistanceProvidedType, ExtensionActivityType, ExtensionCategory, PracticeChangeActivity, RiskAddressedType} from '../../../../functions/src/types';
import {AddActivityComponent} from '../add-activity/add-activity.component';
import {PracticeChangeService} from '../../services/practice-change.service';
import {AddAssistanceTypeComponent} from "../add-assistance-type/add-assistance-type.component";
import {AddARiskTypeComponent} from "../add-risk-type/add-risk-type.component";
import {AddPracticeChangeActivityComponent} from "../add-practice-change-activity/add-practice-change-activity.component";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  constructor(
      private apiService: ApiService,
      public dataService: DataService,
      private loadingService: RSLoadingModalService,
      private rsDialogService: RSDialogService
  ) {
  }

  ngOnInit(): void {
  }

  async syncHort360() {
    this.loadingService.show();
    try {
      await this.apiService.syncHort360();
      this.rsDialogService.showMessageDialog('Sync complete');
    } catch (e) {
      console.error(e);
      this.rsDialogService.showErrorDialog('Something went wrong.');
    }
    this.loadingService.hide();
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  async updateCategory(catId) {
    console.log('updateCategory::: ', catId);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Extension Category ';
    dialogOptions.cancelable = true;
    dialogOptions.closeButton = true;
    dialogOptions.size = RSDialog.Size.MEDIUM;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add out custom component;
    dialogOptions.component = AddCategoryComponent;

    // Use an old fashioned object to assign variable values to;
    const oValues: {category: ExtensionCategory} =
      {category: this.dataService.categories.value.find(c => c.id === catId) || {} as ExtensionCategory};

    console.log('updateCategory::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(
      async (v) => {
        console.log(v, oValues);
        if (v === defaultValues.YES) {
          this.loadingService.show();
          try {
            if (!oValues.category.id) {
              console.log('updateCategory::: Add:: ', oValues.category);
              await this.dataService.categoriesRef.add(oValues.category);
            } else {
              console.log(`updateCategory::: Update:: ${oValues.category.id}`, oValues.category);
              await this.dataService.categoriesRef.doc(oValues.category.id).set(oValues.category);
            }
          } catch (e) {
            this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
          }
          this.loadingService.hide();
        }
      },
      () => { }
    );
  }

  async updateActivity(activityId) {
    console.log('updateActivity::: ', activityId);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Extension Activity ';
    dialogOptions.cancelable = true;
    dialogOptions.closeButton = true;
    dialogOptions.size = RSDialog.Size.MEDIUM;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add out custom component;
    dialogOptions.component = AddActivityComponent;

    // Use an old fashioned object to assign variable values to;
    const oValues: {activity: ExtensionActivityType} =
      {activity: this.dataService.activityTypes.value.find(c => c.id === activityId) || {} as ExtensionActivityType};

    console.log('updateCategory::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(
      async (v) => {
        console.log(v, oValues);
        if (v === defaultValues.YES) {
          this.loadingService.show();
          try {
            if (!oValues.activity.id) {
              console.log('updateCategory::: Add:: ', oValues.activity);
              await this.dataService.activityTypesRef.add(oValues.activity);
            } else {
              console.log(`updateCategory::: Update:: ${oValues.activity.id}`, oValues.activity);
              await this.dataService.activityTypesRef.doc(oValues.activity.id).set(oValues.activity);
            }
          } catch (e) {
            this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
          }
          this.loadingService.hide();
        }
      },
      () => { }
    );
  }

  async updateAssistanceType(assistanceTypeId) {
    console.log('updateAssistanceType::: ', assistanceTypeId);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Assistance Type';
    dialogOptions.cancelable = true;
    dialogOptions.closeButton = true;
    dialogOptions.size = RSDialog.Size.MEDIUM;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add out custom component;
    dialogOptions.component = AddAssistanceTypeComponent;

    // Use an object to assign variable values to;
    const oValues: {assistance: AssistanceProvidedType} =
      {assistance: this.dataService.assistanceProvidedTypes.value.find(c => c.id === assistanceTypeId) || {} as AssistanceProvidedType};

    console.log('updateAssistanceType::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(
      async (v) => {
        console.log(v, oValues);
        if (v === defaultValues.YES) {
          this.loadingService.show();
          try {
            if (!oValues.assistance.id) {
              console.log('updateAssistance::: Add:: ', oValues.assistance);
              await this.dataService.assistanceProvidedTypesRef.add(oValues.assistance);
            } else {
              console.log(`updateAssistance::: Update:: ${oValues.assistance.id}`, oValues.assistance);
              await this.dataService.assistanceProvidedTypesRef.doc(oValues.assistance.id).set(oValues.assistance);
            }
          } catch (e) {
            await this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
          }
          this.loadingService.hide();
        }
      },
      () => { }
    );

  }

  async updatePracticeChangeActivity(practiceChangeActivityId) {
    console.log('updatePracticeChangeActivity::: ', practiceChangeActivityId);
    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Practice Change Activity';
    dialogOptions.cancelable = true;
    dialogOptions.closeButton = true;
    dialogOptions.size = RSDialog.Size.MEDIUM;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add out custom component;
    dialogOptions.component = AddPracticeChangeActivityComponent;

    // Use an object to assign variable values to;
    const oValues: {practiceChange: PracticeChangeActivity} =
      {practiceChange: this.dataService.practiceChangeActivities.value.find(c => c.id === practiceChangeActivityId) || {} as PracticeChangeActivity};

    console.log('updatePracticeChangeActivity::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(
      async (v) => {
        console.log(v, oValues);
        if (v === defaultValues.YES) {
          this.loadingService.show();
          try {
            if (!oValues.practiceChange.id) {
              console.log('updatePracticeChangeActivity::: Add:: ', oValues.practiceChange);
              await this.dataService.practiceChangeActivitiesRef.add(oValues.practiceChange);
              console.log('data', this.dataService);
            } else {
              console.log(`updatePracticeChangeActivity::: Update:: ${oValues.practiceChange.id}`, oValues.practiceChange);
              await this.dataService.practiceChangeActivitiesRef.doc(oValues.practiceChange.id).set(oValues.practiceChange);

            }
          } catch (e) {
            await this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
          }
          this.loadingService.hide();
        }
      },
      () => { }
    );
  }

  async updateRiskType(riskTypeId) {
    console.log('updateRiskType::: ', riskTypeId);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Risk Type';
    dialogOptions.cancelable = true;
    dialogOptions.closeButton = true;
    dialogOptions.size = RSDialog.Size.MEDIUM;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add out custom component;
    dialogOptions.component = AddARiskTypeComponent;

    // Use an object to assign variable values to;
    const oValues: {risk: RiskAddressedType} =
      {risk: this.dataService.riskAddressedTypes.value.find(c => c.id === riskTypeId) || {} as RiskAddressedType};


    console.log('upadateRiskType::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(
      async (v) => {
        console.log(v, oValues);
        if (v === defaultValues.YES) {
          this.loadingService.show();
          try {
            if (!oValues.risk.id) {
              console.log('updateRisk::: Add:: ', oValues.risk);
              await this.dataService.riskAddressedTypesRef.add(oValues.risk);
            } else {
              console.log(`updateRisk::: Update:: ${oValues.risk.id}`, oValues.risk);
              await this.dataService.riskAddressedTypesRef.doc(oValues.risk.id).set(oValues.risk);
            }
          } catch (e) {
            await this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
          }
          this.loadingService.hide();
        }
      },
      () => { }
    );
  }

}
